import React from 'react';
import IconOrientationSectionalLeft from 'components/icons/iconOrientationSectionalLeft';
import IconOrientationSectionalRight from 'components/icons/iconOrientationSectionalRight';
import IconOrientationArmChairLeft from 'components/icons/iconOrientationArmChairLeft';
import IconOrientationArmChairRight from 'components/icons/iconOrientationArmChairRight';
import IconOrientationArmChaiseLeft from 'components/icons/iconOrientationArmChaiseLeft';
import IconOrientationArmChaiseRight from 'components/icons/iconOrientationArmChaiseRight';
import IconOrientationChaiseArmFacingLeft from 'components/icons/iconOrientationChaiseArmFacingLeft';
import IconOrientationChaiseArmFacingRight from 'components/icons/iconOrientationChaiseArmFacingRight';
const getOrientationOptionIcon = (optionName, optionSku, pathname, slug) => {
  let image = '';
  let customItem;
  switch (optionName) {
    case 'Bun Legs':
      image = 'https://joybird2.imgix.net/static-v1/product-options/legs-bun.jpg';
      break;
    case 'Caster Legs':
      image = 'https://joybird2.imgix.net/static-v1/product-options/legs-caster.jpg';
      break;
    case 'Not included':
      image = 'https://joybird2.imgix.net/static-v1/product-options/no-cushion%402x.jpg';
      break;
    case 'Included':
      image = 'https://joybird2.imgix.net/static-v1/product-options/extra-cushion@2x.jpg';
      break;
    case 'Right':
      if (optionSku === '-RAF' && (pathname.includes('daybeds-chaises') || pathname.includes('apartment-desks'))) {
        customItem = <IconOrientationChaiseArmFacingRight />;
      } else if (optionSku === '-SCHR' || optionSku === '-RAF' && slug.includes('louie-chair')) {
        customItem = <IconOrientationArmChairRight />;
      } else if (optionSku === '-SCHSR' || optionSku === '-SACAFR' || optionSku === '-RAF' && !slug.includes('sectional') || optionSku === '-RFB' && !slug.includes('sectional')) {
        customItem = <IconOrientationArmChaiseRight />;
      } else {
        customItem = <IconOrientationSectionalRight />;
      }
      break;
    case 'Left':
      if (optionSku === '-LAF' && (pathname.includes('daybeds-chaises') || pathname.includes('apartment-desks'))) {
        customItem = <IconOrientationChaiseArmFacingLeft />;
      } else if (optionSku === '-SCHL' || optionSku === '-LAF' && slug.includes('louie-chair')) {
        customItem = <IconOrientationArmChairLeft />;
      } else if (optionSku === '-SCHSL' || optionSku === '-SACAFL' || optionSku === '-LAF' && !slug.includes('sectional') || optionSku === '-LFB' && !slug.includes('sectional')) {
        customItem = <IconOrientationArmChaiseLeft />;
      } else {
        customItem = <IconOrientationSectionalLeft />;
      }
      break;
    default:
      image = undefined;
  }
  return {
    image,
    customItem
  };
};
export default getOrientationOptionIcon;